var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isAuthenticated)?_c('div',{staticClass:"be-customer-card-horizonal d-flex justify-center align-center flex-column",style:('background-image: url(' +
      _vm.proposal.metaData.category_proposal_type.IMAGE_DESKTOP +
      ')')},[_c('h2',[_vm._v(" "+_vm._s(_vm.proposal.metaData.category_proposal_type.TITLE)+" ")]),_c('h4',{staticClass:"text-center px-4"},[_vm._v(" "+_vm._s(_vm.proposal.metaData.category_proposal_type.SUBTITLE)+" ")]),_c('v-btn',{staticClass:"mt-5",attrs:{"elevation":"0","color":"primary","to":{
      name: 'RegistrationUser'
    }}},[_vm._v(_vm._s(_vm.proposal.metaData.category_proposal_type.BTN_TEXT))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }